module.exports = __webpack_public_path__ + "static/media/Apple iPad Space Grey.1f41d35b.png";